import { AppSection } from "../AppSection";
import { CardList } from "../CardList";
import iconSrc from "../../icons/recent.svg";
import { useSelector } from "react-redux";

export function RecentSection() {
  const cards = useSelector((state) =>
    state.cards.list.filter(
      (card) => !card.saved && card.id !== state.cards.primaryCardId
    )
  );

  if (cards.length === 0) {
    return null;
  }

  return (
    <AppSection title={"Recent"} iconSrc={iconSrc}>
      <CardList>{cards}</CardList>
    </AppSection>
  );
}
